import React from "react";
import { Modal, Badge, DatePicker, Row, Col, Form, Tooltip } from "antd";
import "./Calendar.css";
import AdnToolTip from "../common/adnToolTip/AdnToolTip";
import AdnInput from "../common/adnInput/AdnInput";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnRate from "../common/adnRate/AdnRate";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import { dateFormat } from "../common/GeneralConfigurations";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../AppRoutes";

const CalendarDetailModal = ({
    title,
    isModalVisible,
    handleModalCancel,
    handleModalOk,
    datePickerDefaultDate,
    onDatePickerChange,
    datePickerValue,
    datePickerFormat,
    textAreaValue,
    textAreaOnChange,
    form,
    initValues,
    eventTypeColor,
    employeeId,
    users,
    submitLoading,
    disabledEmployeeFollowUpEventDate,
}) => {
    return (
        <Modal
            title={title}
            open={isModalVisible}
            onCancel={handleModalCancel}
            onOk={form.submit}
            okButtonProps={initValues.date && { style: { display: "none" } }}
            cancelText={"Back"}
            okText={"Save"}
            confirmLoading={submitLoading}
        >
            <Form
                layout="vertical"
                style={{ marginTop: "1rem" }}
                name="basic"
                form={form}
                initialValues={initValues}
                onFinish={handleModalOk}
                autoComplete="off"
            >
                <Row>
                    <Col span={24}>
                        <Form.Item label={"Employee"}>
                            <Link to={AppRoutes.followUpEventById.createPath(employeeId)}>
                                {initValues.employeeName}
                            </Link>
                        </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <AdnInput
                            name={"eventType"}
                            label={"Type"}
                            type={"text"}
                            readOnly={true}
                            prefix={<Badge color={eventTypeColor} />}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={11}>
                        {initValues.date != null ? (
                            <AdnDatePicker
                                name={"date"}
                                label={"Date"}
                                readOnly={true}
                                format={dateFormat}
                            />
                        ) : (
                            <AdnDatePicker
                                name={"date"}
                                label={"Date"}
                                disabledDate={disabledEmployeeFollowUpEventDate}
                                disabled={false}
                                rules={[{ required: true, message: "Date is required" }]}
                                format={dateFormat}
                            />
                        )}
                    </Col>

                    <Col span={2}></Col>
                    <Col span={11}>
                        {initValues.date ? (
                            <AdnInput name={"doneByName"} label={"Done By"} readOnly={true} />
                        ) : (
                            <AdnDropdown
                                name={"doneById"}
                                label={"Done By"}
                                options={users}
                                rules={[{ required: true, message: "Done by is required" }]}
                                disabled={initValues.date ? true : false}
                            />
                        )}
                    </Col>
                </Row>
                {initValues.eventType ==
                    "Mês 1 - Processo de Admissão * Reunião Individual de Boas Vindas" || (
                        <>
                            <Row gutter={8}>
                                <Col span={8}>
                                    <AdnRate
                                        name={"companyLevel"}
                                        label={
                                            <>
                                                Company level
                                                <>
                                                    <AdnToolTip title={"Satisfaction level in Adentis"} />
                                                </>
                                            </>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: "Company level is required",
                                            },
                                        ]}
                                        disabled={false}
                                    />
                                </Col>

                                <Col span={8}>
                                    <AdnRate
                                        name={"clientLevel"}
                                        label={
                                            <>
                                                Client level
                                                <>
                                                    <AdnToolTip
                                                        title={"Satisfaction level in current client"}
                                                    />
                                                </>
                                            </>
                                        }
                                        rules={[
                                            { required: true, message: "Client level is required" },
                                        ]}
                                        disabled={false}
                                    />
                                </Col>

                                <Col span={8}>
                                    <AdnRate
                                        name={"projectLevel"}
                                        label={
                                            <>
                                                Project level
                                                <>
                                                    <AdnToolTip
                                                        title={"Satisfaction level in current project"}
                                                    />
                                                </>
                                            </>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: "Project level is required",
                                            },
                                        ]}
                                        disabled={false}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                <Row>
                    <Col span={24}>
                        <AdnTextArea
                            name={"feedBack"}
                            label={"Feedback"}
                            maxLength={200}
                            rows={3}
                            showCount={true}
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default CalendarDetailModal;
